import cn from 'classnames'; // Bibliotecas
import './CheckButton.css'; // CSS
import CheckIcon from './../../../img/check-icon.svg'; // IMG

function CheckButton({check, width, borderColor, backgroundColor}){
    const style = {
        width: width || "",
        height: width || "",
        borderColor: check? backgroundColor || "" : borderColor || ""
    };
    
    return (
        <div className={cn("check-button", {"check-button--checked": check})} style={style}>
            <div className="check-button__ball" style={{backgroundColor}}>
                <img src={CheckIcon} className="check-button__icon" />
            </div>
        </div>
    );
}

export default CheckButton;